<div *ngIf="compareObject">
  <div class="selection-container" style="padding: 0 10px 10px;width: 100%;display: inline-flex;align-items: center;">
    <button *ngIf="columns.length > 0" class="btn btn-contextMenu" (click)="onContextMenu($event)">Columns</button>
    <button class="btn btn-contextMenu" (click)="exportToExcel()">Download into Excel</button>
    <ng-container *ngIf="compareObject.SetSelection">
      <p style="margin-right: 10px;font-size: 14px;">Comparing</p>
      <ng-select #select [items]="compareObject.SetSelection" style="width: 100%;"
        [ngClass]="{'compare-dropdown': true}"
        appendTo="{{ 'body' }}"
        (change)="onSelectionChange($event)"
        [clearable]="false"
        [searchable]="true"
        bindLabel="SelectionDisplay"
        bindValue="SelectionValue"
        placeholder="Select sheet"
        [(ngModel)]="compareObject.CurrentSet"
        [name]="'comparison-sheet'">
      </ng-select>
    </ng-container>
  </div>
  
  <div class="comparison-container">
    <div class="mat-parent-td row" ngxDroppable (drop)="drop($event)">
      <div class="mat-td row-label" [ngClass]="columnsCount == 5 ? 'col-3' :  'col-' + columnsCount"></div>
      <div *ngFor="let header of compareObject.Headers;let last=last; let first=first" ngxDraggable [model]="header"
      class="mat-td ngx-dnd-item" [ngClass]="columnsCount == 5 ? 'col' :  'col-' + columnsCount" [class.last]="last">

        <ng-container *ngIf="originalCompareObject.Headers.length > 3">
          <div *ngIf="getVisiblePrevious(header, first)" (click)="previousItem()" class="prev-btn" title="Show previous">Previous</div>
          <div *ngIf="getVisibleNext(header, last)" (click)="nextItem()" class="next-btn" title="Show next">Next</div>
        </ng-container>
          
        <div class="mat-header-label" [innerHTML]="header.HeaderDisplay"></div>
      </div>
    </div>
    <div class="accordion-parent col-12">
      <mat-expansion-panel #panel *ngFor="let group of compareObject.Groups; let i=index;" [expanded]="true" (opened)="setStep(i, group.Name)" hideToggle>
        <mat-expansion-panel-header [collapsedHeight]="'35px'" [expandedHeight]="'35px'" class="panel-header">
          <mat-panel-title>
            <div style="line-height: 2"><p class="mat-label">{{group.HeaderDisplay}}</p></div>
          </mat-panel-title>
          <mat-panel-description *ngIf="panel.expanded" style="justify-content: flex-end;">
            <mat-icon>expand_more</mat-icon>
          </mat-panel-description>
          <mat-panel-description *ngIf="!panel.expanded" style="justify-content: flex-end;">
            <mat-icon>chevron_right</mat-icon>
          </mat-panel-description>
        </mat-expansion-panel-header>

        <ng-template matExpansionPanelContent>
          <div *ngIf="group.Data; else noData" class="mat-row-container">
            <div *ngFor="let data of group.Data; let j=index;" class="mat-parent-td row">
              <div class="mat-td row-label" [ngClass]="columnsCount == 5 ? 'col-3' :  'col-' + columnsCount">
                <p class="mat-label">{{data["#PROPERTY#"]}}</p>
              </div>
              <div class="mat-td" [ngClass]="columnsCount == 5 ? 'col' :  'col-' + columnsCount" *ngFor="let header of compareObject.Headers;">
                <p *ngIf="data['#TYPE#'] == 'LABEL'">{{data[header.Name]}}</p>
                <ng-container *ngIf="data['#TYPE#'] == 'TEXTBOX'">
                  <input #textbox type="text"
                  class="form-control"
                  [attr.name]="data['#PROPERTY#'] + '_' + data[header.Name]"
                  autocomplete="off"
                  [name]="data['#PROPERTY#'] + '_' + data[header.Name]"
                  [(ngModel)]="data[header.Name]"
                  [value]="data[header.Name]"
                  (change)="onValueChange(group.Name, data['#PROPERTY#'], header.Name, textbox.value)">
                </ng-container>
              </div>
            </div>
          </div>
          <ng-template #noData>
            <div class="mat-parent-td col-12">
              <div class="mat-td">
                <p>Loading...</p>
              </div>
            </div>
          </ng-template>
        </ng-template>
        <!-- <mat-action-row>
          <button *ngIf="!first" mat-button color="warn" (click)="prevStep()">Previous</button>
          <button *ngIf="!last" mat-button color="primary" (click)="nextStep()">Next</button>
          <button *ngIf="last" mat-button color="primary" (click)="nextStep()">End</button>
        </mat-action-row> -->
      </mat-expansion-panel>
    </div>
    <div class="button-container">
      <!-- <div class="button-action" (click)="testAction('')" style="margin-left: 5px;">Award</div> -->
    </div>
  </div>
</div>

<context-menu [useBootstrap4]="true">
  <ng-template contextMenuItem passive="true">
    <div class="columns-display">
      <div *ngFor="let column of columns; let i=index" class="mat-checkbox-container">
        <mat-checkbox matCheckbox #matCheckbox="matCheckbox"
        class="form-checkbox column-checkbox"
        (change)="onChange(column, $event)"
        [value]="column.Name"
        [(ngModel)]="column.isChecked">{{column.HeaderDisplay}}</mat-checkbox>
      </div>
    </div>
  </ng-template>
</context-menu>